import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import ServiceCompletStatic from './ServiceCompletStatic';

const ServiceComplet = () => (
  <ServicePageShell strapiApiId="service-complet" defaultTitle="Service Complet" StaticFallback={ServiceCompletStatic} />
);

export default ServiceComplet;
